const state = {
    vehicles: localStorage.getItem('vehicles') ? JSON.parse(localStorage.getItem('vehicles')) : [],
    // fleets: localStorage.getItem('fleets')
    //   ? JSON.parse(localStorage.getItem('fleets')) : [],
    vgroups: localStorage.getItem('vgroups') ? JSON.parse(localStorage.getItem('vgroups')) : [],
    report_vehicles: sessionStorage.getItem('report_vehicles') ?
        JSON.parse(sessionStorage.getItem('report_vehicles')) :
        [],
    report_vehicle: sessionStorage.getItem('report_vehicle') ? JSON.parse(sessionStorage.getItem('report_vehicle')) : {},
    start_date: sessionStorage.getItem('start_date') ? sessionStorage.getItem('start_date') : '',
    end_date: sessionStorage.getItem('end_date') ? sessionStorage.getItem('end_date') : '',
    start_datetime: sessionStorage.getItem('start_datetime') ? sessionStorage.getItem('start_datetime') : '',
    end_datetime: sessionStorage.getItem('end_datetime') ? sessionStorage.getItem('end_datetime') : '',
    alarms: localStorage.getItem('alarms') ? JSON.parse(localStorage.getItem('alarms')) : [],
    notifications: localStorage.getItem('notifications') ? JSON.parse(localStorage.getItem('notifications')) : [],
    groups: localStorage.getItem('groups') ? JSON.parse(localStorage.getItem('groups')) : [],
    cities: localStorage.getItem('cities') ? JSON.parse(localStorage.getItem('cities')) : [],
    brands: localStorage.getItem('brands') ? JSON.parse(localStorage.getItem('brands')) : [],
    can_type: localStorage.getItem('can_type') ? JSON.parse(localStorage.getItem('can_type')) : [],
    settings: localStorage.getItem('settings') ? JSON.parse(localStorage.getItem('settings')) : null,
  vehicleTypes: localStorage.getItem('vehicleTypes') ? JSON.parse(localStorage.getItem('vehicleTypes')) : []
};

const mutations = {
    setAllVehicles(state, allVehicles) {
        state.vehicles = allVehicles;
    },
    // setAllFleets (state, allFleets) {
    //   state.fleets = allFleets
    // },
    setAllGroups(state, allGroups) {
        state.vgroups = allGroups;
    },
    setReportData(state, [key, value]) {
        state[key] = value;
    },
    setAlarmUtils(state, [key, value]) {
        state[key] = value;
    },
    setManagementUtils(state, [key, value]) {
        state[key] = value;
    },
    setCities(state, cities) {
        state.cities = cities;
    },
    setSettings(state, settings) {
        state.settings = settings;
    },
    setBrands(state, brands) {
        state.brands = brands;
    },
  setVehicleTypes(state, allVehicleTypes) {
      state.vehicleTypes = allVehicleTypes;
  }
};

const getters = {
    generic() {
        return state;
    },
    vehicles() {
        return state.vehicles;
    },
    alarms() {
        return state.alarms;
    },
    all_vehicle_groups(){
        return state.vgroups;
    },
  allVehicleTypes() {
      return state.vehicleTypes
  }
};

export default {
    state,
    mutations,
    getters,
};
